import DvrIcon from '@mui/icons-material/Dvr';
import CardAction from '../../../../../../../../components/card/CardAction';

export default function ViewFilesAction({
  className,
  onClick,
} = {
  className: '',
  onClick: () => null,
}) {
  return (
    <CardAction
      icon={<DvrIcon aria-hidden='false' />}
      actionHandler={onClick}
      label='View'
      className={`btn-primary ${className}`}
      ariaLabel='View file'
      title='View file'
      data-test='view-file-action'
      tabIndex={0}
      aria-hidden='false'
    />
  );
}
